__turbopack_context__.v({
  "backLink": "scientificCalculator-module__k7Ak4G__backLink",
  "btnClear": "scientificCalculator-module__k7Ak4G__btnClear",
  "btnEquals": "scientificCalculator-module__k7Ak4G__btnEquals",
  "btnFullScreen": "scientificCalculator-module__k7Ak4G__btnFullScreen",
  "btnFunc": "scientificCalculator-module__k7Ak4G__btnFunc",
  "btnMemory": "scientificCalculator-module__k7Ak4G__btnMemory",
  "btnMode": "scientificCalculator-module__k7Ak4G__btnMode",
  "btnNum": "scientificCalculator-module__k7Ak4G__btnNum",
  "btnOp": "scientificCalculator-module__k7Ak4G__btnOp",
  "calcContainer": "scientificCalculator-module__k7Ak4G__calcContainer",
  "display": "scientificCalculator-module__k7Ak4G__display",
  "footer": "scientificCalculator-module__k7Ak4G__footer",
  "fullScreen": "scientificCalculator-module__k7Ak4G__fullScreen",
  "grid": "scientificCalculator-module__k7Ak4G__grid",
  "mode": "scientificCalculator-module__k7Ak4G__mode",
  "wrapper": "scientificCalculator-module__k7Ak4G__wrapper",
});
